import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { Observable, finalize } from 'rxjs';
import { IGetFacebookPostsData } from '../../Models/IFacebookPost';
import { FacebookService } from '../../Services/facebook.service';
import {faExternalLink} from '@fortawesome/free-solid-svg-icons';
import { FacebookCommentDto, IFacebookComment } from '../../Models/IFacebookComment';
import { HelperFunctions } from '../../../../helpers/HelperFunctions';

@Component({
  selector: 'app-facebook-comments',
  templateUrl: './facebook-comments.component.html',
  styleUrl: './facebook-comments.component.scss'
})
export class FacebookCommentsComponent implements OnInit {
  @Input() postId?: number;
  comments: Array<IFacebookComment> = [];
  isLoading = false;

  isLoadingComments = false;
  commentCount: number = 0;
  errorComments: string = ''

  error: string = '';

  constructor(
    private facebookService: FacebookService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.postId) {
      this.loadPostComments();
    } else {
      this.error = 'No post ID provided';
    }
  }

  
  loadPostComments(): void {
    this.isLoadingComments = true;
    this.errorComments = '';
    
    this.facebookService.getPostComments(this.postId as number)
      .pipe(
        finalize(() => {
          this.isLoadingComments = false;
          this.cdr.detectChanges(); // Force change detection
        })
      )
      .subscribe({
        next: (response) => {
          if (response) {
            this.comments = Array.isArray(response) ? response : [response];
            this.commentCount = this.comments.length;
          } else {
            this.errorComments = 'No comments found or invalid response format';
            console.warn('No comments data in response:', response);
          }
        },
        error: (error) => {
          this.errorComments = 'Failed to load comments. Please try again.';
          console.error('Error loading comments:', error);
        }
      });
  }

  formatDatetime(time: string): string {
    return HelperFunctions.formatDatetime(time);
  }

 
 getInitials(fullName: string): string {
   return HelperFunctions.getInitials(fullName);
 }
  
}
